"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const esg_1 = require("./esg");
exports.theme = (0, esg_1.createWebsiteTheme)({
    name: 'ESGDark',
    mode: 'dark',
});
//# sourceMappingURL=esg-dark.js.map